import { render } from "./blogSearch.vue?vue&type=template&id=bd1150a4&scoped=true"
import script from "./blogSearch.vue?vue&type=script&lang=js"
export * from "./blogSearch.vue?vue&type=script&lang=js"

import "./blogSearch.vue?vue&type=style&index=0&id=bd1150a4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd1150a4"]])

export default __exports__